// Test IDs for the LXRA Marketplace (Phase 5): directory, public profiles,
// photographer onboarding, studio profile editor and LXRA owner moderation.

export const PHOTOGRAPHERS_PAGE = {
  root: 'photographers-page',
  hero: 'photographers-directory-hero',
  applyButton: 'photographers-directory-apply-button',
  locationInput: 'photographers-filter-location-input',
  useMyLocation: 'photographers-filter-use-my-location-button',
  sortSelect: 'photographers-filter-sort-select',
  styleChips: 'photographers-filter-style-chips',
  styleChip: (style) => `photographers-filter-style-${style.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`,
  priceSlider: 'photographers-filter-price-slider',
  priceReadout: 'photographers-filter-price-readout',
  distanceSlider: 'photographers-filter-distance-slider',
  distanceReadout: 'photographers-filter-distance-readout',
  verifiedSwitch: 'photographers-filter-verified-only-switch',
  filtersOpen: 'photographers-filters-open-button',
  filtersPanel: 'photographers-filters-panel',
  filtersClear: 'photographers-filters-clear-button',
  resultsGrid: 'photographers-results-grid',
  resultsCount: 'photographers-results-count',
  resultsEmpty: 'photographers-results-empty',
  resultsError: 'photographers-results-error',
  resultsRetry: 'photographers-results-retry-button',
  originLabel: 'photographers-origin-label',
  applySection: 'photographers-apply-section',
  applySectionButton: 'photographers-apply-section-button',
  card: (handle) => `photographer-card-${handle}`,
  cardView: (handle) => `photographer-card-view-profile-${handle}`,
  cardRequest: (handle) => `photographer-card-request-to-book-${handle}`,
  cardDistance: (handle) => `photographer-card-distance-${handle}`,
  cardPrice: (handle) => `photographer-card-price-${handle}`,
  cardVerified: (handle) => `photographer-card-verified-${handle}`,
  cardRating: (handle) => `photographer-card-rating-${handle}`,
  availableOnInput: 'photographers-filter-available-on-input',
};

export const PHOTOGRAPHER_PROFILE = {
  root: 'photographer-profile-page',
  hero: 'photographer-profile-hero',
  name: 'photographer-profile-name',
  tagline: 'photographer-profile-tagline',
  verifiedBadge: 'photographer-verified-badge',
  requestButton: 'photographer-profile-request-to-book-button',
  portfolioButton: 'photographer-profile-view-portfolio-button',
  bioSection: 'photographer-profile-bio-section',
  styleChips: 'photographer-profile-style-chips',
  facts: 'photographer-profile-facts',
  portfolioSection: 'photographer-profile-portfolio-section',
  portfolioImage: (i) => `photographer-portfolio-image-${i}`,
  packagesSection: 'photographer-profile-packages-section',
  packageCard: (id) => `photographer-package-${id}`,
  packageBook: (id) => `photographer-package-book-${id}`,
  galleriesSection: 'photographer-profile-public-galleries',
  galleryCard: (slug) => `photographer-gallery-${slug}`,
  instagramLink: 'photographer-profile-instagram-link',
  websiteLink: 'photographer-profile-website-link',
  backLink: 'photographer-profile-back-link',
  availabilitySection: 'photographer-profile-availability-section',
  ratingBadge: 'photographer-profile-rating-badge',
  reviewsSection: 'photographer-profile-reviews-section',
  reviewCard: (id) => `photographer-review-${id}`,
};

export const BOOK_WITH_STRIP = {
  root: 'booking-with-photographer-strip',
  name: 'booking-with-photographer-name',
  change: 'booking-with-photographer-change-link',
};

export const SIGNUP_PHOTOGRAPHER_MARKETPLACE = {
  studioNameInput: 'signup-photographer-studio-name-input',
  homeBaseInput: 'signup-photographer-home-base-input',
  styleChips: 'signup-photographer-style-chips',
  styleChip: (style) => `signup-photographer-style-${style.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`,
  modeHint: 'signup-photographer-mode-hint',
  pendingBanner: 'photographer-signup-pending-banner',
};

export const ADMIN_TENANT = {
  switcherTrigger: 'admin-tenant-switcher-trigger',
  switcherMenu: 'admin-tenant-switcher-menu',
  switcherItem: (id) => `admin-tenant-switcher-item-${id}`,
  switcherAll: 'admin-tenant-switcher-item-all',
  viewingAsBanner: 'admin-viewing-as-banner',
  pendingBanner: 'admin-pending-approval-banner',
  suspendedBanner: 'admin-suspended-banner',
  tabMyProfile: 'admin-tab-my-profile',
  tabPhotographers: 'admin-tab-photographers',
};

export const ADMIN_MY_PROFILE = {
  root: 'admin-my-profile',
  handleInput: 'admin-my-profile-handle-input',
  nameInput: 'admin-my-profile-name-input',
  taglineInput: 'admin-my-profile-tagline-input',
  bioInput: 'admin-my-profile-bio-input',
  styleChips: 'admin-my-profile-style-chips',
  styleChip: (style) => `admin-my-profile-style-${style.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`,
  homeBaseInput: 'admin-my-profile-home-base-input',
  serviceAreaInput: 'admin-my-profile-service-area-input',
  radiusSlider: 'admin-my-profile-radius-slider',
  radiusReadout: 'admin-my-profile-radius-readout',
  accentColor: 'admin-my-profile-accent-color-input',
  accentHex: 'admin-my-profile-accent-hex-input',
  accentPreview: 'admin-my-profile-accent-preview',
  logoInput: 'admin-my-profile-logo-input',
  coverInput: 'admin-my-profile-cover-input',
  logoPreview: 'admin-my-profile-logo-preview',
  coverPreview: 'admin-my-profile-cover-preview',
  instagramInput: 'admin-my-profile-instagram-input',
  websiteInput: 'admin-my-profile-website-input',
  portfolioPicker: 'admin-my-profile-portfolio-picker',
  portfolioCandidate: (id) => `admin-my-profile-portfolio-candidate-${id}`,
  portfolioCount: 'admin-my-profile-portfolio-count',
  saveButton: 'admin-my-profile-save-button',
  viewPublicLink: 'admin-my-profile-view-public-link',
  statusBadge: 'admin-my-profile-status-badge',
  geocodedLabel: 'admin-my-profile-geocoded-label',
  availabilityCard: 'admin-my-profile-availability-card',
  availabilityCalendar: 'admin-my-profile-availability-calendar',
  availabilitySave: 'admin-my-profile-availability-save-button',
  reviewsCard: 'admin-my-profile-reviews-card',
  reviewsAverage: 'admin-my-profile-reviews-average',
  reviewsList: 'admin-my-profile-reviews-list',
};

export const ADMIN_PHOTOGRAPHERS = {
  root: 'admin-photographers',
  table: 'admin-photographers-table',
  row: (id) => `admin-photographers-row-${id}`,
  status: (id) => `admin-photographers-status-${id}`,
  approve: (id) => `admin-photographers-approve-${id}`,
  suspend: (id) => `admin-photographers-suspend-${id}`,
  reinstate: (id) => `admin-photographers-reinstate-${id}`,
  verifiedToggle: (id) => `admin-photographers-verified-toggle-${id}`,
  viewAs: (id) => `admin-photographers-view-as-${id}`,
  viewProfile: (id) => `admin-photographers-view-profile-${id}`,
  remove: (id) => `admin-photographers-remove-${id}`,
  filterSelect: 'admin-photographers-filter-select',
  pendingCount: 'admin-photographers-pending-count',
  empty: 'admin-photographers-empty',
  tabBadge: 'admin-tab-photographers-badge',
  reviewsButton: (id) => `admin-photographers-reviews-${id}`,
  reviewsDialog: 'admin-photographers-reviews-dialog',
  reviewRow: (id) => `admin-photographers-review-row-${id}`,
  reviewToggle: (id) => `admin-photographers-review-toggle-${id}`,
  scoreBadge: (id) => `admin-photographers-screening-score-${id}`,
  decisionBadge: (id) => `admin-photographers-screening-decision-${id}`,
  queueHint: 'admin-photographers-pending-queue-hint',
};

export const ADMIN_TEAM_INVITE_KIND = {
  select: 'admin-team-invite-kind-select',
  badge: (id) => `admin-team-invite-kind-${id}`,
};
